import React from 'react';
import { Value } from '../Value';
export const BulletList = ({ values }) => {
    if (values.length === 1) {
        return React.createElement(Value, null, values[0]);
    }
    return (React.createElement(React.Fragment, null, values.map((value) => (React.createElement(Value, { key: value, spaceBetween: true }, `• ${value}`)))));
};
